<template lang="pug">
b-modal#domainCustomAddAssign(
  ref="domainCustomAddAssign"
  :title="$t('ui.combine.domain_custom_add_assign')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.domain_name')").mb-0
      DebounceInput(
        size="sm"
        ref="domain_name"
        required
        type="text"
        :dirty="$v.domain_name.$dirty"
        :error="$v.domain_name.$error"
        v-model.trim.lazy="$v.domain_name.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.domain_name" :name="$t('ui.domain_name')")
    b-form-group(:label="$t('ui.operator_id')").mb-0
      DebounceInput(
        size="sm"
        ref="operator_id"
        required
        alphaNum
        type="text"
        :dirty="$v.operator_id.$dirty"
        :error="$v.operator_id.$error"
        v-model.trim.lazy="$v.operator_id.$model"
        :maxLength="$v.operator_id.$params.maxLength.max"
        :disabled="loading"
      )
      ValidateResult(:value="$v.operator_id" :name="$t('ui.operator_id')")
    b-form-group(:label="$t('ui.name_server')").mb-0
      DebounceInput(
        size="sm"
        ref="name_server"
        required
        type="text"
        :dirty="$v.name_server.$dirty"
        :error="$v.name_server.$error"
        v-model.trim.lazy="$v.name_server.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.name_server" :name="$t('ui.name_server')")
    b-form-group(:label="$t('ui.server_account')").mb-0
      DebounceInput(
        size="sm"
        ref="server_account"
        required
        type="text"
        :dirty="$v.server_account.$dirty"
        :error="$v.server_account.$error"
        v-model.trim.lazy="$v.server_account.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.server_account" :name="$t('ui.server_account')")
    b-form-group(:label="$t('ui.service_provider')").mb-0
      DebounceInput(
        size="sm"
        ref="service_provider"
        required
        type="text"
        :dirty="$v.service_provider.$dirty"
        :error="$v.service_provider.$error"
        v-model.trim.lazy="$v.service_provider.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.service_provider" :name="$t('ui.service_provider')")
    b-form-group(:label="$t('ui.module')").mb-0
      ModuleLookup(
        size="sm"
        ref="module"
        required
        type="array"
        :dirty="$v.module.$dirty"
        :error="$v.module.$error"
        v-model.trim.lazy="$v.module.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.module" :name="$t('ui.module')")    
    b-form-group(:label="$t('ui.remark')").mb-0
      DebounceInput(
        size="sm"
        type="text"
        :dirty="$v.remark.$dirty"
        :error="$v.remark.$error"
        v-model.trim.lazy="$v.remark.$model"
        :maxLength="$v.remark.$params.maxLength.max"
        :disabled="loading"
      )
      ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import ModuleLookup from "@/library/ModuleLookup";
import DomainTypeLookup from "@/library/DomainTypeLookup";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    ModuleLookup,
    DomainTypeLookup
  },
  props: {
    // item: {
    //   type: Object
    // },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      domain_name: "",
      operator_id: "",
      module: "MEMBER",
      name_server: "",
      server_account: "",
      service_provider: "",
      remark: ""
    };
  },
  computed: {
  },
  validations: {
    domain_name: {
      required,
    },
    operator_id: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    module: {
      required,
    },
    name_server: {
      required,
    },  
    server_account: {
      required,
    },
    service_provider: {
      required,
    },
    remark: {
      required,
      maxLength: maxLength(50)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.domainCustomAddAssignUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          domain_name: this.domain_name,
          operator_id: this.operator_id,
          module: this.module,
          name_server: this.name_server,
          server_account: this.server_account,
          service_provider: this.service_provider
        };

        if (this.remark.trim() != '')
          json.remark = this.remark;

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_domain", this.feedback.status);
                }
                this.$refs.domainCustomAddAssign.hide();
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.domain_name = "";
      this.operator_id = "";
      this.module = "";
      this.name_server = "";
      this.server_account = "";
      this.service_provider = "";
      this.remark = "";
    },
    shown: function() {
      this.$v.$reset();
      this.module = "MEMBER";
      this.$refs.domain_name.$el.focus();
    }
  }
};
</script>
